// Visa types (mirror api/shared/schemas.js VISA_TYPES) + display helpers.
export const VISA_TYPES = [
  { value: 'exit_reentry', label: 'Exit / Re-entry' },
  { value: 'final_exit', label: 'Final Exit' },
  { value: 'entry', label: 'Entry' },
];

export function visaTypeLabel(value) {
  return VISA_TYPES.find((t) => t.value === value)?.label || value;
}

// Badge variant per status (matches the app's Badge variants).
export const VISA_STATUS_VARIANT = {
  pending: 'warning',
  approved: 'info',
  fulfilled: 'success',
  rejected: 'danger',
  cancelled: 'default',
  expired: 'danger',
};

export const VISA_STATUS_LABEL = {
  pending: 'Pending approval',
  approved: 'Approved — awaiting HR',
  fulfilled: 'Issued',
  rejected: 'Rejected',
  cancelled: 'Cancelled',
  expired: 'Expired',
};
